export default "__VITE_ASSET__BwnCYmUt__"